import { useEffect, useState } from 'react';
import { dungeonService } from '../../services/DungeonService';
import { useCharacterProgressionStore } from '../../store/characterProgressionSlice';
import { LEVEL_CAP, xpCumulativeFor } from '../../data/progression.config';
import './PlayerVitals.scss';

interface Vitals {
  life: number;
  maxLife: number;
  shield: number;
  maxShield: number;
}

const ZERO: Vitals = { life: 0, maxLife: 0, shield: 0, maxShield: 0 };

export const PlayerVitals = () => {
  const [vitals, setVitals] = useState<Vitals>(ZERO);
  const currentLevel = useCharacterProgressionStore((s) => s.level);
  const currentXP = useCharacterProgressionStore((s) => s.xp);

  useEffect(() => {
    const interval = setInterval(() => {
      const player = dungeonService.getPlayer();
      if (player) {
        setVitals({
          life: player.life,
          maxLife: player.maxLife,
          shield: player.shield,
          maxShield: player.maxShield,
        });
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const lifePct = vitals.maxLife > 0 ? (vitals.life / vitals.maxLife) * 100 : 0;
  const shieldPct =
    vitals.maxShield > 0 ? (vitals.shield / vitals.maxShield) * 100 : 0;

  const lifeColor =
    lifePct > 50 ? '#4caf50' : lifePct > 25 ? '#ff9800' : '#f44336';

  const currentLevelXp = xpCumulativeFor(currentLevel);
  const nextLevelXp =
    currentLevel < LEVEL_CAP ? xpCumulativeFor(currentLevel + 1) : null;
  const xpInLevel = currentXP - currentLevelXp;
  const xpRange = nextLevelXp !== null ? nextLevelXp - currentLevelXp : 0;
  const xpPct = xpRange > 0 ? (xpInLevel / xpRange) * 100 : 100;

  return (
    <div className="player-vitals">
      <div className="player-vitals-track">
        <div
          className="player-vitals-fill"
          style={{ width: `${lifePct}%`, backgroundColor: lifeColor }}
        />
        <span className="player-vitals-value">
          {vitals.life} / {vitals.maxLife}
        </span>
      </div>

      {vitals.maxShield > 0 && (
        <div className="player-vitals-track">
          <div
            className="player-vitals-fill player-vitals-fill--shield"
            style={{ width: `${shieldPct}%` }}
          />
          <span className="player-vitals-value">
            {vitals.shield} / {vitals.maxShield}
          </span>
        </div>
      )}

      <div className="player-vitals-track">
        <div
          className="player-vitals-fill player-vitals-fill--xp"
          style={{ width: `${xpPct}%` }}
        />
        <span className="player-vitals-value">
          Niv {currentLevel}
          {nextLevelXp !== null ? ` · ${xpInLevel} / ${xpRange}` : ' · MAX'}
        </span>
      </div>
    </div>
  );
};
